module.exports = __webpack_public_path__ + "static/media/bg.8b74cbf2.jpg";